import React, { useState, useEffect, useContext } from 'react';
import { TextField, CircularProgress } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';

import api from '../../services/api';
import { AuthContext } from '../../context/Auth/AuthContext';

const ContactSelect = ({ 
  value, 
  onChange, 
  error, 
  helperText, 
  returnObject = false, 
  onBlur,
  endpoint = '/contacts'
}) => {
  const { user } = useContext(AuthContext);
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [selectedContact, setSelectedContact] = useState(null);

  useEffect(() => {
    if (!user.companyId || !endpoint) return;

    const fetchContacts = async () => {
      setLoading(true);
      try {
        const { data } = await api.get(endpoint, {
          params: { searchParam: search, pageNumber: 1 },
        });
        setContacts(data.contacts);
      } catch (err) {
        console.error(`Error cargando contactos desde ${endpoint}`, err);
        setContacts([]);
      } finally {
        setLoading(false);
      }
    };
    
    const debounce = setTimeout(() => {
      fetchContacts();
    }, 500);

    return () => clearTimeout(debounce);
    
  }, [search, user.companyId, endpoint]);

  useEffect(() => {
    if (!value) {
      setSelectedContact(null);
      return;
    }

    if (returnObject && value.id) {
      setSelectedContact(value);
      return;
    }

    const found = contacts.find(c => c.id === value);
    if (found) {
      setSelectedContact(found);
    } else if (!selectedContact || selectedContact.id !== value) {
      setSelectedContact(selectedContact);
    }
  }, [value, contacts, returnObject]);

  return (
    <Autocomplete
      options={contacts}
      loading={loading}
      value={selectedContact}
      size="small"
      getOptionLabel={(option) => option.name}
      noOptionsText="No hay opciones"
      loadingText="Cargando..."
      getOptionSelected={(option, val) => val && option.id === val.id}
      onChange={(event, newValue) => {
        setSelectedContact(newValue);
        if (returnObject) {
          onChange(newValue);
        } else {
          onChange(newValue ? newValue.id : '');
        }
      }}
      onInputChange={(event, newInputValue) => {
        setSearch(newInputValue);
      }}
      onBlur={onBlur} 
      renderInput={(params) => (
        <TextField
          {...params}
          label={"Seleccionar contacto"}
          variant="outlined"
          error={error}
          helperText={helperText}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default ContactSelect;